import updateReduxAction from 'modules/redux/actions/update'
import validateReduxAction from 'modules/redux/actions/validate'
import REDUX_ACTION from 'modules/redux/constants/action'

/**
 * Updates the `value` at the given `payload.path` and validate the object.
 * @param {Object} params
 *        {number} params.type
 *        {Object} params.payload
 *        {string} params.payload.path
 *        {string} params.payload.value
 *        {Object} [params.payload.options]
 */
function updateAndValidateReduxAction (params) {
  return dispatch => {
    dispatch(
      updateReduxAction(params)
    )
    dispatch(
      validateReduxAction({
        type: REDUX_ACTION.VALIDATE,
        payload: {
          ...params.payload
        }
      })
    )
  }
}

export default updateAndValidateReduxAction
